import { Avatar, Box, Card, CardHeader, CardProps, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import React from 'react';

import { Formatters } from 'app/utils/formatters';

import { Comment } from '../model/comment';

interface CommentProps extends CardProps {
    comment: Comment;
}

const AVATAR_STR_LEN = 2;

export class CommentComp extends React.Component<CommentProps> {
    public render(): React.ReactNode {
        const comment = this.props.comment;

        return (
            <Card elevation={4} {...this.props}>
                <Box display='flex'>
                    <CardHeader
                        style={{ whiteSpace: 'nowrap' }}
                        avatar={<Avatar>{comment.owner?.username.substr(0, AVATAR_STR_LEN).toUpperCase()}</Avatar>}
                        title={Formatters.userDisplayName(comment.owner)}
                        subheader={
                            comment.addedOn ? format(parseISO(comment.addedOn), 'MM/dd/yyyy hh:mm:ss a') : undefined
                        }
                    />
                    <div>
                        <Typography
                            variant='body2'
                            color='textPrimary'
                            className='m-2'
                            sx={{ overflowWrap: 'anywhere' }}
                        >
                            {this.props.comment.comment}
                        </Typography>
                    </div>
                </Box>
            </Card>
        );
    }
}
